import { RootState } from "@/app/appStore";
import { requestServise } from "@/shared";
import $api from "@/shared/http";
import { getProblemDetailsMessage, toApiError } from "@/shared/http/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { isAxiosError } from "axios";
import {
  CartFilterType,
  CreateDealerOrderResult,
  DealerRemainsCartResponse,
  ItemToCart,
} from "../../model/types";

// Сортировка по колонкам выполняется на клиенте, order нужен только
// для стабильного порядка строк между страницами
const DEALER_REMAINS_ORDER = { type: "asc", field: "Code" };

export const addDealerRemainsItemsCart = createAsyncThunk<
  unknown,
  { items: ItemToCart[] },
  { rejectValue: string }
>("cart/addDealerRemainsItemsCart", async (body, { rejectWithValue }) => {
  try {
    const response = await $api.post("/basket/dealer/remains/items", body);
    return response.data;
  } catch (error) {
    return rejectWithValue(getProblemDetailsMessage(error));
  }
});

export const deleteDealerRemainsCart = requestServise.delete(
  "cart/deleteDealerRemainsCart",
  "/basket/dealer/remains",
);

export const createDealerRemainsOrder =
  requestServise.noBodyPost<CreateDealerOrderResult>(
    "cart/createDealerRemainsOrder",
    "/dealerorders/create/basket/dealer-remains",
  );

export const checkDealerRemainsCart = createAsyncThunk<
  boolean,
  void,
  { rejectValue: string }
>("cart/checkDealerRemainsCart", async (_, { rejectWithValue }) => {
  try {
    await $api.get("/basket/dealer/remains");
    return true;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      return false;
    }
    return rejectWithValue(toApiError(error).message);
  }
});

export const fetchDealerRemainsCart = createAsyncThunk<
  DealerRemainsCartResponse,
  void,
  { state: RootState; rejectValue: string }
>(
  "cart/fetchDealerRemainsCart",
  async (_, { getState, rejectWithValue, signal }) => {
    const state = getState().cart;
    const body = {
      order: DEALER_REMAINS_ORDER,
      pagination: {
        pageSize: state.dealerRemainsPageSize,
        pageNumber: state.dealerRemainsPageNumber,
      },
      filters: [] as CartFilterType,
    };
    try {
      const response = await $api.post<DealerRemainsCartResponse>(
        "/basket/dealer/remains",
        body,
        { signal },
      );
      return response.data;
    } catch (error) {
      if (
        signal.aborted ||
        (isAxiosError(error) && error.code === "ERR_CANCELED")
      ) {
        return rejectWithValue("canceled");
      }
      // 404 — корзины неликвидов ещё нет (или она очищена)
      if (isAxiosError(error) && error.response?.status === 404) {
        return { items: [], totalCount: 0 };
      }
      return rejectWithValue(toApiError(error).message);
    }
  },
);
